import type { RouteObject } from "react-router-dom";

export const warehouseManagementRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Redo Warehouse" },
    async lazy() {
      const { Page } = await import("../../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { WarehouseManagementPage } = await import(
            "../pages/warehouse-management/warehouse-management-page"
          );

          return { Component: WarehouseManagementPage };
        },
      },
      {
        path: "error-messages",
        async lazy() {
          const { ErrorMessagesPage } = await import(
            "../pages/error-messages/error-messages-page"
          );

          return { Component: ErrorMessagesPage };
        },
      },
      {
        path: "developer-tools",
        async lazy() {
          const { DeveloperToolsPage } = await import(
            "../../developer-tools/developer-tools-page"
          );

          return { Component: DeveloperToolsPage };
        },
      },
      {
        path: "redo-supplies-price-books",
        async lazy() {
          const { RedoSuppliesPriceBooksPage } = await import(
            "../pages/redo-supplies-price-books/redo-supplies-price-books-page"
          );

          return { Component: RedoSuppliesPriceBooksPage };
        },
      },
    ],
  },
];
